<template>
    <div class="agreement-dialog" :style="show ? 'display:block':'display:none'">
        <div class="agreement-content">
            <!-- content -->
            <section class="dialog-body">
                <div class="game-detail-text">
                    <NewsContent :newsId="agreementNewsId"></NewsContent>
                </div>
            </section>
            <!-- footer -->
            <section class="dialog-footer">
                <van-button type="danger" block @click="onAgree">我同意参赛协议并报名</van-button>
            </section>
        </div>

    </div>
</template>
<script>
    import {
        Button,
    } from "vant";
    import NewsContent from "@/components/NewsContent.vue";

    export default {
        name: 'Agreement',
        props: {
            show: Boolean,
            agreementNewsId: String
        },
        components: {
            [Button.name]: Button,
            NewsContent
        },
        data() {
            return {
                // isShow:this.show
            }
        },
        methods: {
            onAgree() {
                // this.isShow = false;
                this.$emit('onAgree', { agree: true });
            }
        },
    }
</script>
<style lang="less">
    .agreement-dialog {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        overflow: hidden;
        z-index: 100;
        background-color: rgba(0, 0, 0, 0.7);

    }

    .agreement-content {
        display: flex;
        flex-direction: column;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0px;
        overflow: hidden;
        z-index: 101;
        background-color: #fff;

    }

    .dialog-header {
        position: relative;
        height: 50px;
        line-height: 50px;
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        border-bottom: 1px solid #efefef;
    }

    .dialog-close {
        position: absolute;
        width: 30px;
        height: 30px;
        top: 10px;
        right: 10px;
        line-height: 30px;
    }

    .dialog-body {
        flex: 1;
        overflow: hidden;
        padding: 0 10px;

    }


    .dialog-footer {
        height: 50px;
        padding: 0 20px;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        border-top: 1px solid #efefef;
    }

    .dialog-footer .van-button {
        height: 35px;
    }

    .game-detail-text {
        color: #666;
        font-size: 12px;
        width: 100%;
        height: 100%;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        webkit-overflow-scrolling: touch;
    }

    .conMenu {
        background: #e50021;
        font-size: 20px;
        float: left;
        width: 100%;
        margin-bottom: 30px;
    }

    .menuListRight {
        width: 100%;
        float: left;
        padding-bottom: 50px;
    }

    .menuListRight li a {
        color: #fff;
        float: left;
        width: 100%;
        text-decoration: none;
        font-size: 16px;
        padding: 20px 35px;
        border-bottom: 1px solid #c80a23;
    }

    .menuListRight li a:hover {
        background: #c80a23;
    }

    .menuListRight .active a {
        background: #c80a23;
    }

    .conMenu .cnDesc {
        font-size: 32px;
        font-weight: 300;
        padding: 20px 20px 10px 30px;
        color: #fff;
    }

    .conMenu .enDesc {
        font-size: 14px;
        font-weight: normal;
        padding: 0 30px;
        margin-bottom: 20px;
        color: #fff;
    }

    .conMenu .line {
        border-top: 2px solid #fff;
        width: 20px;
        height: 0;
        display: inline-block;
        margin-left: 35px;
        margin-bottom: 40px;
    }

    .mb20 {
        margin-bottom: 20px;
    }

    .gama-conent-desc {
        padding-left: 15px;
    }
</style>